// extracted by mini-css-extract-plugin
module.exports = {"overAll":"crossareatagediter_overAll__11umB","statusFlex":"crossareatagediter_statusFlex__24l-8"};